module.exports = __webpack_public_path__ + "static/media/mais.f89f5f84.svg";